import { defineComponent as _defineComponent } from 'vue'


  
export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    modelValue: Boolean,
    label: String,
    disabled: Boolean,
    additionalClass: [String, Array],
    labelBold: String,
    labelClass: { type: String, required: false },
    labelHidden: { type: String, required: false },
    toggleClass: { type: String, required: false },
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;

  const toggleSelection = (event: Event) => {
    emits("update:modelValue", !props.modelValue);
  };

const __returned__ = { props, emits, toggleSelection }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})